import { streakAchievement } from './helpers';

export default streakAchievement(365, 230);
